module.exports = __webpack_public_path__ + "img/wisemapping.png";